'use client';

import { useEffect } from 'react';

export default function AdPluggClient({ accountId, zone, width, height, fallbackUrl, }: {
  accountId: string
  zone: string
  width: number
  height: number
  fallbackUrl?: string
}) {
  useEffect(() => {
    const script = document.createElement(`script`);
    script.text = `
      (function(ac) {
        var d = document, s = 'script', id = 'adplugg-adjs';
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id; js.async = 1;
        js.src = '//www.adplugg.com/apusers/serve/' + ac + '/js/1.1/ad.js';
        fjs.parentNode.insertBefore(js, fjs);
      }('${accountId}'));`;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [accountId,]);

  return (
    <div>
      <div className="adplugg-tag" data-adplugg-zone={zone} />
    </div>
  );
}
